import {useTranslation} from "next-i18next";
import Image from "next/image";
import Button from "../common/Button";
import IconEmail from "../../data/Icons/leon-inmobiliaria-icons-e-mail.svg";
import IconPhone from "../../data/Icons/leon-inmobiliaria-icons-phone.svg";
import IconFax from "../../data/Icons/leon-inmobiliaria-icons-fax.svg";
import {PeopleImages} from "../../data/StaticImages";

interface ContactUsPanelProps {
	title?: string;
	image?: string;
	contactName?: string;
	tel?: string;
	fax?: string;
	email?: string;
}

function ContactUsPanel(props: ContactUsPanelProps) {
	const {t} = useTranslation();
	const title = props.title ?? t("components.contactUsPanel.defaultTitle");
	const image = props.image ?? PeopleImages.Andrea;
	const contactName =
		props.contactName ?? t("components.contactUsPanel.defaultName");
	const tel = props.tel ?? t("components.contactUsPanel.defaultTel");
	const fax = props.fax ?? t("components.contactUsPanel.defaultFax");
	const email = props.email ?? t("components.contactUsPanel.defaultEmail");

	return (
		<>
			<div className="w-full flex justify-center my-10">
				<div className="bg-leo-divider-gray-2 h-[2px] w-10/12"/>
			</div>
			<div className="flex flex-col md:flex-row items-center justify-center gap-16 my-20 px-6">
				<Image quality={90} alt="" src={image} width={426} height={513}/>
				<div className="flex flex-col justify-center items-start gap-12">
					<h3 className="">{title}</h3>
					<div className="flex flex-col justify-center items-start gap-2">
						<p className="font-bold text-[24px]">{contactName}</p>
						<div className="space-x-2 flex flex-row gap-1 items-center ">
							<IconPhone className="h-6 w-6"/>
							<p className="text-[18px] text-leo-orange">
								<a href={`tel:${tel}`}>{tel}</a>
							</p>
						</div>
						<div className="space-x-2 flex flex-row gap-1 items-center">
							<IconFax className="h-6 w-6"/>
							<p className="text-[18px]">{fax}</p>
						</div>
						<div className="space-x-2 flex flex-row gap-1 items-center">
							<IconEmail className="h-6 w-6"/>
							<p className="text-[18px] text-leo-orange">
								<a href={`mailto:${email}`}>{email}</a>
							</p>
						</div>
					</div>
					<Button
						text={"Zum Kontaktformular"}
						href="/kontakt"
						transparent={false}
						border={false}
						padding={"px-6 py-[14px]"}
						className="rounded-[10px]"
					/>
				</div>
			</div>
		</>
	);
}

export default ContactUsPanel;
